const axios = require('axios').default;

export const AxiosLocal = axios.create({
    // baseURL: 'http://127.0.0.1:8000/api/v1.6/meetmo/',
    baseURL: 'https://fox16-api-dev.meetmo.io/api/v1.6/meetmo/',
    headers: {"Content-Type": "application/json","Authorization":"bearer "+localStorage.getItem('accessToken')}
    
  });